import React from 'react';

import './style.scss';

interface propsInterface {
  left?: string | React.ReactNode;
  right?: string | number | React.ReactNode;
  className?: string;
}

const RowInfo = ({ left, right, className }: propsInterface) => (
  <div className={`v-row-info ${className || ''}`}>
    <span>{left}</span>
    <span>{right}</span>
  </div>
);

export default RowInfo;
